import React from 'react';

import HomePresentation from "../components/HomePresentation";
import './StylePages/Home.css';
import HomeTechnicalSkills from "../components/HomeTechnicalSkills";
import HomePassion from "../components/HomePassion";
import HomeIntroduction from "../components/HomeIntroduction";
import HomeCredit from "../components/HomeCredit";

const Home = () => {
    return (
        <div>
                <main className="MainContainer" style={{ width: "100%", height: "100vh"}}>
                        <HomePresentation/>
                        <HomeIntroduction/>
                        <HomeTechnicalSkills/>
                        <HomePassion/>
                        <HomeCredit/>
                </main>
        </div>
    );
};

export default Home;
